import { 
    apiBizSetSignAndAd,
    apiBizConfirmContract
    } from "@/apis/api.js"; 
import { 
    getDefaultContract
    } from "@/apis/company/contractMgt.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_contract_id: 'bizSignContract/set_contract_id',
    set_house_id: 'bizSignContract/set_house_id',
    set_contract: 'bizSignContract/set_contract',
    set_sign_data: 'bizSignContract/set_sign_data',
}

// count state 必須是 Object
const state = {
    bizContractId: null,
    bizHouseId: null,
    bizContract: null,
    signImage: null,
    advertisement: null
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_CONTRACT_ID: (state) => {
        return state.bizContractId
    },
    GET_BIZ_HOUSE_ID: (state) => {
        return state.bizHouseId
    },
    GET_BIZ_CONTRACT: (state) => {
        return state.bizContract
    },
    IS_SIGNED: (state) => {
        if(state.signImage){
            return true
        }else{
            return false
        }
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    setContractId ( {commit, dispatch, state} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id, data);
            const params = {
                contractCid: state.bizContractId.contractCid,
                contractVersionId: state.bizContractId.contractVersionId
            }
            dispatch('getBizContract', params)
            .then(()=>{
                resolve()
            })
        })
    },
    getBizContract ( {dispatch, commit}, params ) {
        return new Promise((resolve, reject) => {
            getDefaultContract(params)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract, res.data.result.contractHtml);
                    commit(types.set_house_id, res.data.result.houseCid);
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
                resolve()
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: '系統發生未預期錯誤，請再試一次',type: 'error'})
                reject(err)
            })
        })
    },
    saveBizContractSign ( {dispatch, state} ) {
        return new Promise((resolve, reject) => {

            let data = {
                "contractCid": state.bizContractId.contractCid,   
                "contractVersionId": state.bizContractId.contractVersionId,
                "landlordSignature": state.signImage,
                "advertisementImage": state.advertisement,
            }

            apiBizSetSignAndAd(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('confirmBizContract')
                    .then(()=>{
                        resolve()
                    })
                }else{
                    if(res.data.errorCode === 221019){
                        dispatch('setAlarmStatus', {status: true,title: '無權限，非業務本人帳號簽名',type: 'error'})
                    }else{
                        dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                }
            })
            .catch(err => {
                reject(err)
                dispatch('setAlarmStatus', {status: true,title: '系統發生未預期錯誤，請再試一次',type: 'error'})
            })
        })
    },
    confirmBizContract ( {commit, state} ) {
        return new Promise((resolve, reject) => {

            let data = state.bizContractId.contractCid

            apiBizConfirmContract(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setSignData ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_sign_data, data);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_contract_id](state, data){
        state.bizContractId = data
    },
    [types.set_house_id](state, data){
        state.bizHouseId = data
    },
    [types.set_contract](state, data){
        state.bizContract = data
    },
    [types.set_sign_data](state, data){
        if(data.type == 'ad'){
            state.advertisement = data.value
        }else if(data.type == 'sign'){
            state.signImage = data.value
        }
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/bizSignContract.js